import moment from "moment";

// find working time diff in one day. All params and result is in seconds
// function singleDayWorkingTimeDiff(
//   inTime,
//   outTime,
//   workingStartTime,
//   workingEndTime
// ) {
//   if (workingStartTime < workingEndTime) {
//     return Math.max(
//       0,
//       Math.min(outTime, workingEndTime) - Math.max(inTime, workingStartTime)
//     );
//   } else if (workingStartTime > workingEndTime) {
//     return (
//       Math.max(0, workingEndTime - inTime) +
//       Math.max(0, outTime - workingStartTime)
//     );
//   } else {
//     // ignore working time
//     return outTime - inTime;
//   }
// }

// calculate time difference obeying working time in second
// export function workingTimeDiff(
//   inDateTime,
//   outDateTime,
//   workingStartTime,
//   workingEndTime,
// ) {

//   const inMoment = moment(inDateTime);
//   const outMoment = moment(outDateTime);
//   const diffDays = outMoment.diff(inMoment, "days");
//   const inTime =
//     inMoment.hour() * 3600 + inMoment.minute() * 60 + inMoment.second();
//   const outTime =
//     outMoment.hour() * 3600 + outMoment.minute() * 60 + outMoment.second();

//   if (diffDays === 0) {
//     if in same day
//     return singleDayWorkingTimeDiff(
//       inTime,
//       outTime,
//       workingStartTime,
//       workingEndTime
//     );
//   }

//   else {
//     const diffEndTime = singleDayWorkingTimeDiff(
//       0,
//       outTime,
//       workingStartTime,
//       workingEndTime
//     );

//     const diffStartTime = singleDayWorkingTimeDiff(
//       inTime,
//       86400,
//       workingStartTime,
//       workingEndTime
//     );

//     if (diffDays > 1) {
//       // if there is at minimum 2 days difference
//       const oneDayDiff = singleDayWorkingTimeDiff(
//         0,
//         86400,
//         workingStartTime,
//         workingEndTime
//       );
//       return diffStartTime + diffEndTime + oneDayDiff * (diffDays - 1);
//     } else {
//       // only one day difference
//       return diffStartTime + diffEndTime;
//     }
//   }
// }

export function workingTimeDiff(
  inDateTime,
  outDateTime,
  workingStartTime,
  workingEndTime,
  responseTimeSLA
) {
  const inMoment = moment(inDateTime);
  const outMoment = moment(outDateTime);
  const diffDays = outMoment.diff(inMoment, "days");
  const isSameDay = outMoment.isSame(inMoment, "days");
  const inTime =
    inMoment.hour() * 3600 + inMoment.minute() * 60 + inMoment.second();
  const outTime =
    outMoment.hour() * 3600 + outMoment.minute() * 60 + outMoment.second();

  const inWorkStart =
    parseInt(moment.unix(workingStartTime).format("HH")) * 3600 +
    parseInt(moment.unix(workingStartTime).format("mm")) * 60 +
    parseInt(moment.unix(workingStartTime).format("ss"));
  const outWorkEnd =
    parseInt(moment.unix(workingEndTime).format("HH")) * 3600 +
    parseInt(moment.unix(workingEndTime).format("mm")) * 60 +
    parseInt(moment.unix(workingEndTime).format("ss"));

  if (inTime >= inWorkStart && inTime <= outWorkEnd) {
    if (isSameDay === true) {
      return outTime - inTime;
    } else {
      return responseTimeSLA + 1;
    }
  } else if (inTime <= inWorkStart) {
    if (diffDays === 0) {
      return outTime - inWorkStart;
    } else if (diffDays >= 1) {
      return responseTimeSLA + 1;
    }
  } else if (inTime >= outWorkEnd) {
    if (diffDays === 0) {
      return outTime - (inTime + inWorkStart);
    } else if (diffDays >= 1) {
      return responseTimeSLA + 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/module-case-management/util.js